<template>
    <div id="addLeague">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit, reset }">
            <v-form ref="form" lazy-validation @submit.prevent="handleSubmit(submit)" @reset.prevent="reset">
                <v-row class="justify-center align-center">
                    <v-col cols="10">
                        <ValidationProvider v-slot="{ errors }" name="Nazwa ligi" :rules="{required:true, alpha:true, min:2, max:20}">
                            <v-text-field 
                            v-model="form.leagueName"
                            label="Nazwa"
                            :error-messages="errors"
                            required
                            clearable
                            clear-icon="close"
                            ></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row class="justify-center align-center">
                    <v-col cols="10">
                        <ValidationProvider v-slot="{ errors }" name="Avatar" :rules="{required:true, image, size:4999}">
                            <v-file-input
                                v-model="form.leagueAvatar"
                                show-size
                                :rules="rules"
                                accept="image/png,image/jpeg,image/bmp,image/svg"
                                :error-messages="errors"
                                placeholder="Wybierz Avatar"
                                prepend-icon="mdi-camera"
                                clearable
                                clear-icon="close"
                                label="Avatar"
                            ></v-file-input>
                        </ValidationProvider>
                        
                    </v-col>                        
                </v-row>
                <v-row class="justify-center align-center">
                    <v-col cols="10">
                        <v-row class="justify-end align-center">
                            <v-btn 
                            color="#76EB6C"
                            dark
                            top
                            right
                            large
                            type="submit"
                            >
                                <v-icon left big color="#8asd11">mdi-plus</v-icon>
                                <span>Dodaj ligę</span>
                            </v-btn>
                        </v-row>
                    </v-col>                        
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>
<script>
import {  ValidationObserver, ValidationProvider } from 'vee-validate'
export default {
    name:'addLeague',
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        const defaultForm = Object.freeze({
            leagueName:'',
            leagueAvatar:''
        }) 
        return{
            form: Object.assign({},defaultForm),
            defaultForm,
            submitPossitive:false,
            submitError:false
        };
    },
    methods:{
        submit(){
            this.$refs.observer.validate()            
            .then(result=>{
                if(result){
                    let leagueData = {
                        leagueName: this.form.leagueName,
                        leagueAvatar: this.form.leagueAvatar,
                    }
                    this.$store.dispatch('addNewLeague',leagueData)
                    //Na czas local-->
                    this.$refs.observer.reset();
                    this.$refs.form.reset();
                    this.$emit("changeDialogState",false);
                    // <--
                    /*
                    .then((response)=>{
                        if(response.status == 201 || response.status == 200){
                            this.$refs.observer.reset()
                            this.$refs.form.reset()
                            this.submitPossitive=true;
                        }
                    })
                    .catch(()=>{
                        this.submitError=true;
                    })
                    */
                }
            })
            .catch((err)=>{
                console.log(err);
                this.submitError=true;
            })
        }
    }   
}
</script>
<style>
    #addLeague{
        width:80%;
    }
</style>
